import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { formatDateTime, WindowType } from "../../../../util";
import { Comment, CommentReply, UserBase } from "../../../backend/backendapi";
import { TextareaAutogrowDirective } from 'vue-textarea-autogrow-directive';
import TextSuggest from '../../../textsuggest/TextSuggest';

declare var window: WindowType;

@Component({
    name: 'CommentComponent',
    components: {
        Reply: require('./reply.vue.html').default,
        TextSuggest,
    },
    directives: {
        'autogrow': TextareaAutogrowDirective,
    }
})
export default class CommentComponent extends Vue {
    @Prop({ required: true })
    comment!: Comment;
    @Prop({ required: true })
    userEmails!: string[];
    @Prop({ default: false })
    readonly!: boolean;
    @Prop({ default: false })
    lockeddown!: boolean;

    private editComment: string | null = null;
    private newReply: CommentReply | null = null;

    private get userId(): string {
        return window.application.kanban.user?.id!;
    }

    private get userNameShort(): string {
        return this.comment.aspNetUser?.firstName?.substring(0, 1) + "" + this.comment.aspNetUser?.lastName?.substring(0, 1);
    }

    //
    private save(): void {
        this.$emit('comment-save', this.comment, this.editComment);

        this.editComment = null;
    }

    private deleteComment(): void {
        this.$emit('comment-delete', this.comment);
    }

    private reply(): void {
        this.newReply = new CommentReply();
        this.newReply.aspNetUserId = window.application.kanban.user?.id!;
        this.newReply.aspNetUser = new UserBase(window.application.kanban.user!);
        this.newReply.commentId = this.comment.id;
        this.newReply.createdOn = new Date();
        this.newReply.text = '';
    }

    private newReplySave(reply: CommentReply, text: string): void {
        if (!this.newReply)
            return;
        this.$emit('reply-create', this.comment, text);
        this.newReply = null;
    }

    private replySave(reply: CommentReply, text: string): void {
        this.$emit('reply-save', this.comment, reply, text);
    }

    private replyDelete(reply: CommentReply): void {
        this.$emit('reply-delete', this.comment, reply);
    }

    //util
    private formatDateTime(d: Date | undefined): string {
        if (!d)
            return '';
        return formatDateTime(d);
    }
}